import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api";

const NICHES = [
  "Real Estate Agents","Insurance Agents","Loan Consultants","Digital Marketing Agency",
  "Web Development Company","Interior Designers","Restaurants","Hospitals & Clinics",
  "Car Dealers","Gym & Fitness Centers","CA & Tax Consultants","Wedding Planners",
  "Travel Agencies","IT Companies","Schools & Coaching Centers","Builders & Contractors",
  "Solar Energy Companies","Pharma Companies","Export Companies","Event Planners",
  "Beauty Parlours & Salons","Dentists","Architects","Lawyers & Advocates",
  "Pest Control Services","Packers & Movers","Catering Services","Photography Studios",
];

const CITIES = [
  "Delhi","Mumbai","Bangalore","Chennai","Hyderabad","Kolkata","Pune","Ahmedabad",
  "Jaipur","Lucknow","Chandigarh","Surat","Indore","Bhopal","Nagpur","Noida",
  "Gurgaon","Mohali","Panchkula","Ludhiana","Amritsar","Jodhpur","Agra","Varanasi",
];

const FREQUENCIES = [
  { value: 30,   label: "Every 30 Minutes", desc: "48 times/day · Best for active sales" },
  { value: 60,   label: "Every 1 Hour",     desc: "24 times/day · Good balance" },
  { value: 120,  label: "Every 2 Hours",    desc: "12 times/day · Steady flow" },
  { value: 240,  label: "Every 4 Hours",    desc: "6 times/day · Moderate" },
  { value: 360,  label: "Every 6 Hours",    desc: "4 times/day · Recommended" },
  { value: 1440, label: "Once a Day",       desc: "1 time/day · Morning digest" },
];

const S = {
  page: { minHeight:"100vh", background:"#050510", color:"#fff", fontFamily:"'DM Sans',sans-serif", padding:28 },
  card: { background:"linear-gradient(135deg,#0d0d1f,#111128)", border:"1px solid #ffffff0d", borderRadius:20, padding:28, marginBottom:16 },
  inp:  { width:"100%", background:"#050510", border:"1px solid #ffffff22", borderRadius:10, padding:"12px 14px", color:"#fff", fontFamily:"'DM Sans',sans-serif", fontSize:14, boxSizing:"border-box", outline:"none" },
  lbl:  { display:"block", color:"#9ca3af", fontSize:11, marginBottom:8, textTransform:"uppercase", letterSpacing:1 },
};

export default function AutoSetup() {
  const [niche, setNiche]       = useState("Real Estate Agents");
  const [city, setCity]         = useState("Delhi");
  const [frequency, setFreq]    = useState(360);
  const [autoEnabled, setAuto]  = useState(false);
  const [isPremium, setIsPremium] = useState(false);
  const [loading, setLoading]   = useState(true);
  const [saving, setSaving]     = useState(false);
  const [msg, setMsg]           = useState("");
  const [msgType, setMsgType]   = useState("success");
  const navigate = useNavigate();

  useEffect(() => {
    Promise.all([
      API.get("/schedule/status").catch(() => ({ data: {} })),
      API.get("/auth/me").catch(() => ({ data: {} })),
    ]).then(([sr, mr]) => {
      const s = sr.data;
      const m = mr.data;
      setNiche(s.niche || m.niche || "Real Estate Agents");
      setCity(s.city || m.city || "Delhi");
      setFreq(s.interval_minutes || m.lead_frequency || 360);
      setAuto(s.active || m.auto_enabled || false);
      setIsPremium(m.plan && m.plan !== "free");
      setLoading(false);
    });
  }, []);

  const save = async () => {
    if (!isPremium) { navigate("/payment"); return; }
    setSaving(true);
    try {
      await Promise.all([
        API.post("/save-preferences", { niche, city, lead_frequency: frequency }),
        API.post("/update-frequency", { frequency }),
        API.post("/toggle-auto", { enabled: autoEnabled }),
      ]);
      setMsg("✅ Settings saved! Auto-generation updated.");
      setMsgType("success");
    } catch(e) {
      setMsg(e?.response?.data?.detail || "Failed to save");
      setMsgType("error");
    }
    setTimeout(() => setMsg(""), 3000);
    setSaving(false);
  };

  const toggleAuto = async (val) => {
    if (!isPremium) { navigate("/payment"); return; }
    setAuto(val);
    try {
      await API.post("/toggle-auto", { enabled: val });
      setMsg(val ? "✅ Auto-generation enabled" : "⏸ Auto-generation paused");
      setMsgType("success");
    } catch(e) {
      setMsg("Failed to update");
      setMsgType("error");
    }
    setTimeout(() => setMsg(""), 2000);
  };

  if (loading) return (
    <div style={{ ...S.page, display:"flex", alignItems:"center", justifyContent:"center" }}>
      <div style={{ textAlign:"center", color:"#9ca3af" }}>Loading...</div>
    </div>
  );

  return (
    <div style={S.page}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;700&family=Syne:wght@900&display=swap" rel="stylesheet"/>
      <div style={{ maxWidth:720, margin:"0 auto" }}>

        {/* Header */}
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:28 }}>
          <div>
            <h1 style={{ fontFamily:"'Syne',sans-serif", fontSize:26, fontWeight:900, margin:0 }}>⚡ Auto Lead Generation</h1>
            <p style={{ color:"#6b7280", fontSize:13, margin:"4px 0 0" }}>Configure automatic lead delivery to your email</p>
          </div>
          <button onClick={() => navigate("/dashboard")} style={{ background:"transparent", color:"#9ca3af", border:"1px solid #ffffff22", borderRadius:10, padding:"9px 16px", cursor:"pointer", fontSize:13, fontFamily:"'DM Sans',sans-serif" }}>← Dashboard</button>
        </div>

        {/* Premium gate */}
        {!isPremium && (
          <div style={{ background:"#f59e0b18", border:"1px solid #f59e0b44", borderRadius:16, padding:24, marginBottom:20, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            <div>
              <div style={{ color:"#f59e0b", fontWeight:700, fontSize:15, marginBottom:4 }}>🔒 Premium Feature</div>
              <div style={{ color:"#9ca3af", fontSize:13 }}>Auto lead generation requires a paid plan (Starter, Pro or Enterprise)</div>
            </div>
            <button onClick={() => navigate("/payment")} style={{ background:"linear-gradient(135deg,#00d4aa,#00b894)", color:"#050510", border:"none", borderRadius:10, padding:"11px 20px", cursor:"pointer", fontFamily:"'DM Sans',sans-serif", fontWeight:700, fontSize:14, whiteSpace:"nowrap" }}>
              Upgrade →
            </button>
          </div>
        )}

        {/* On/Off Toggle */}
        <div style={{ ...S.card, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
          <div>
            <div style={{ fontFamily:"'Syne',sans-serif", fontSize:18, fontWeight:900, marginBottom:4 }}>Auto Lead Generation</div>
            <div style={{ color:"#9ca3af", fontSize:13 }}>{autoEnabled ? "🟢 Active — leads being generated automatically" : "⏸ Paused — click to enable"}</div>
          </div>
          <div onClick={() => toggleAuto(!autoEnabled)} style={{ width:56, height:28, borderRadius:14, background: autoEnabled?"#00d4aa":"#ffffff22", cursor: isPremium?"pointer":"not-allowed", position:"relative", transition:"background 0.3s", flexShrink:0 }}>
            <div style={{ width:22, height:22, borderRadius:"50%", background:"#fff", position:"absolute", top:3, left: autoEnabled?31:3, transition:"left 0.3s", boxShadow:"0 2px 6px #00000044" }}/>
          </div>
        </div>

        {/* Niche & City */}
        <div style={S.card}>
          <h3 style={{ fontFamily:"'Syne',sans-serif", fontSize:16, fontWeight:900, marginBottom:20 }}>What leads do you want?</h3>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16 }}>
            <div>
              <label style={S.lbl}>Industry / Niche</label>
              <select value={niche} onChange={e => setNiche(e.target.value)} style={{ ...S.inp, color: niche?"#fff":"#6b7280" }}>
                {NICHES.map(n => <option key={n} value={n}>{n}</option>)}
              </select>
            </div>
            <div>
              <label style={S.lbl}>City</label>
              <select value={city} onChange={e => setCity(e.target.value)} style={{ ...S.inp, color: city?"#fff":"#6b7280" }}>
                {CITIES.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>
          </div>
        </div>

        {/* Frequency */}
        <div style={S.card}>
          <h3 style={{ fontFamily:"'Syne',sans-serif", fontSize:16, fontWeight:900, marginBottom:6 }}>How often?</h3>
          <p style={{ color:"#9ca3af", fontSize:13, marginBottom:20 }}>Choose how frequently new leads are generated and emailed to you</p>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
            {FREQUENCIES.map(f => (
              <div key={f.value} onClick={() => isPremium && setFreq(f.value)} style={{ background: frequency===f.value?"#00d4aa15":"#050510", border:`1px solid ${frequency===f.value?"#00d4aa44":"#ffffff11"}`, borderRadius:12, padding:16, cursor: isPremium?"pointer":"not-allowed", transition:"all 0.2s" }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:4 }}>
                  <div style={{ fontWeight:700, fontSize:14, color: frequency===f.value?"#00d4aa":"#fff" }}>{f.label}</div>
                  {frequency===f.value && <span style={{ background:"#00d4aa", color:"#050510", borderRadius:6, padding:"2px 8px", fontSize:11, fontWeight:700 }}>SELECTED</span>}
                </div>
                <div style={{ color:"#6b7280", fontSize:12 }}>{f.desc}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Summary */}
        <div style={{ background:"#00d4aa0d", border:"1px solid #00d4aa33", borderRadius:16, padding:20, marginBottom:20 }}>
          <div style={{ fontWeight:700, fontSize:14, marginBottom:8, color:"#00d4aa" }}>📋 Your Configuration</div>
          <div style={{ display:"flex", gap:24, fontSize:13, color:"#9ca3af", flexWrap:"wrap" }}>
            <span>🎯 Niche: <strong style={{ color:"#fff" }}>{niche}</strong></span>
            <span>📍 City: <strong style={{ color:"#fff" }}>{city}</strong></span>
            <span>⏱ Frequency: <strong style={{ color:"#fff" }}>{FREQUENCIES.find(f=>f.value===frequency)?.label}</strong></span>
            <span>Status: <strong style={{ color: autoEnabled?"#00d4aa":"#f87171" }}>{autoEnabled?"Active":"Paused"}</strong></span>
          </div>
        </div>

        {/* Message */}
        {msg && (
          <div style={{ background: msgType==="success"?"#00d4aa18":"#f8717118", border:`1px solid ${msgType==="success"?"#00d4aa44":"#f8717144"}`, borderRadius:10, padding:"10px 16px", marginBottom:16, color: msgType==="success"?"#00d4aa":"#f87171", fontSize:14 }}>
            {msg}
          </div>
        )}

        {/* Save button */}
        <button onClick={save} disabled={saving || !isPremium} style={{ width:"100%", background: isPremium?"linear-gradient(135deg,#00d4aa,#00b894)":"#ffffff11", color: isPremium?"#050510":"#6b7280", border:"none", borderRadius:12, padding:15, fontFamily:"'DM Sans',sans-serif", fontWeight:700, fontSize:16, cursor: isPremium?"pointer":"not-allowed" }}>
          {saving ? "Saving..." : isPremium ? "💾 Save Configuration" : "🔒 Upgrade to Enable Auto-Generation"}
        </button>
      </div>
    </div>
  );
}
